import {ddJugeTokenTimeOut, selectDingdingThird, bindDingDingThird, DingDingGetUserToken} from '@/api/dd'
import dingtalk from 'dingtalk-jsapi'

export function ddLogin(callback) {
  const Authorization = localStorage.getItem('Authorization')
  if (Authorization) {
    window.console.log('ddLogin, token存在, 验证token是否过期')
    ddTokenTimeOut(callback)
  } else {
    ddReady(callback)
  }
  // ddReady(callback)
}

export function ddTokenTimeOut(callback) {
  ddJugeTokenTimeOut().then(res => {
    console.log('ddJugeTokenTimeOut', res)
    if (res.code === 0) {
      window.console.log('表示没有过期')
      callback()
    } else {
      window.console.log('表示已经过期')
      localStorage.removeItem('Authorization')
      ddReady()
    }
  })
}

export function ddReady(callback) {
  dingtalk.ready(() => {
    window.console.log('进来dingtalk方法')
    localStorage.removeItem('Authorization')
    dingtalk.runtime.permission.requestAuthCode({
      corpId: 'dingcc49658297bd767bf5bf40eda33b7ba0',
      onSuccess: info => {
        window.console.log('进来dingtalk的onSuccess')
        const code = info.code
        selectDingdingThird(1, code).then(res => {
          window.console.log('selectDingdingThird', res)
          const data = res.data
          if (data && data.length > 0) {
            const accountId = data[0].coreAccountId
            DingDingGetUserToken(accountId).then(res => {
              if (res.code === 0) {
                localStorage.removeItem('Authorization')
                const token = 'Bearer ' + res.data
                localStorage.setItem('Authorization', token)
                callback()
              }
            })
          } else {
            dingtalk.runtime.permission.requestAuthCode({
              corpId: 'dingcc49658297bd767bf5bf40eda33b7ba0',
              onSuccess: info => {
                const authCode = info.code
                bindDingDingThird(1, authCode).then(res => {
                  if (res.code === 0) {
                    const data = res.data
                    const accountId = data[0].coreAccountId
                    DingDingGetUserToken(accountId).then(res => {
                      if (res.code === 0) {
                        localStorage.removeItem('Authorization')
                        const token = 'Bearer ' + res.data
                        localStorage.setItem('Authorization', token)
                        callback()
                      }
                    })
                  } else {
                    window.console.error('绑定失败')
                  }
                })
              }
            })
          }
        })
      },
      onFail: err => {
        window.console.error('onFail', err)
      }
    })
  })
}
